<template>
  <div id="data-list-list-view" class="datatable-container">
    <!--Filter-->
    <file-filter @change="onChangeFilter" />

    <vx-card class="mt-5">
      <h4 class="card-title">Results ({{ totalItem }})</h4>
      <vs-table stripe ref="table" :data="files">
        <div
          slot="header"
          class="flex flex-wrap-reverse justify-end flex-grow mb-2"
        >
          <div class="flex flex-wrap-reverse data-list-btn-container ">
            <vs-button
              @click="refresh"
              color="primary"
              type="border"
              size="small"
              class="ml-3"
              >Refresh</vs-button
            >
          </div>
        </div>

        <template slot="thead">
          <vs-th>File Name</vs-th>
          <vs-th>Status</vs-th>
          <vs-th>Created At</vs-th>
          <vs-th>Completed At</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                <p class="product-name">
                  <a @click="getRecord(tr.id)"> {{ tr.fileName }}</a>
                </p>
              </vs-td>
              <vs-td>
                <vs-chip
                  :color="getStatusColor(tr.fileStatus)"
                  class="product-order-status"
                >
                  {{ tr.fileStatus }}
                </vs-chip>
              </vs-td>
              <vs-td>
                <p class="product-name">
                  {{ tr.createdAt | moment('DD MMM YYYY, hh:mm A') }}
                </p>
              </vs-td>
              <vs-td>
                <p class="product-name">
                  {{ tr.completedAt | moment('DD MMM YYYY, hh:mm A') }}
                </p>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
      <template v-if="totalPage > 0">
        <vs-pagination
          :total.sync="totalPage"
          v-model="currentPage"
        ></vs-pagination>
      </template>
    </vx-card>
  </div>
</template>

<script>
import fileStatuses from '@/mixins/file-status'
import FileFilter from '@/views/apps/file/FileFilter'

export default {
  components: {
    FileFilter,
  },
  mixins: [fileStatuses],
  data() {
    return {
      selected: [],
      itemsPerPage: 25,
      isMounted: false,
      currentPage: 1,
      pageTotal: 0,
      totalItem: 0,
      totalPage: 0,
      sortBy: 'createdAt,DESC',
      fileId: '',
      filter: {
        fileName: null,
        createdAt: null,
        status: null,
        completedAt: null,
      },
    }
  },
  watch: {
    currentPage(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.getRecords()
      }
    },
  },
  computed: {
    files() {
      return this.$store.state.files.files || []
    },
    filterParams() {
      const entries = Object.entries(this.filter)
      if (!entries.length) return null

      return entries
        .filter(([, value]) => value)
        .map(([key, value]) => ({
          [key]: key === 'status' ? value : { $contL: value },
        }))
    },
    sortParams() {
      const entries = Object.entries(this.sortBy)
      return entries.length
        ? entries.map(([field, direction]) => `${field},${direction}`).join('')
        : ''
    },
  },
  created() {
    this.getRecords()
  },
  methods: {
    async refresh() {
      location.reload()
    },
    async getRecords() {
      try {
        let response = await this.$store.dispatch('files/fetchRecords', {
          page: this.currentPage,
          limit: this.itemsPerPage,
          s: this.search,
          sort: this.sortBy,
        })
        this.currentPage = parseInt(response.headers['x-pagination-page'])
        this.pageTotal = parseInt(response.headers['x-pagination-count'])
        this.totalItem = parseInt(response.headers['x-pagination-total'])
        this.totalPage = parseInt(response.headers['x-pagination-page-count'])
      } catch (e) {}
    },
    async getRecord(doc) {
      this.$router.push('/files/' + doc).catch(() => {})
    },
    async onChangeFilter(search) {
      this.currentPage = 1
      this.search = search
      await this.getRecords()
    },
  },
  mounted() {
    this.isMounted = true
  },
}
</script>
